/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20 2.5h-7.25v8.75h8.75V4c0-.8284-.6716-1.5-1.5-1.5Zm1.5 10.25h-8.75v8.75H20c.8284 0 1.5-.6716 1.5-1.5v-7.25ZM4 2.5h7.25v19H4c-.8284 0-1.5-.6716-1.5-1.5V4c0-.8284.6716-1.5 1.5-1.5ZM4 1C2.3432 1 1 2.3432 1 4v16c0 1.6569 1.3432 3 3 3h16c1.6569 0 3-1.3431 3-3V4c0-1.6568-1.3431-3-3-3H4Z"
    clipRule="evenodd"
  />,
  'Published'
);
